// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3ROCh","title":"ClientReferral_title__M2JL7","itemText":"ClientReferral_itemText__2EJQ8"};